/*
Komonenta HOMEPAGE

S obzirom da je ovo one-page stranica. Ova komponenta ce biti ceo sajt.

*/
import React from 'react';
import './HomePage.scss';
import Background from '../Background/Background';
import Navbar from '../Navbar/Navbar';
import TimerPage from '../TimerPage/TimerPage';
import DesignInsightPage from '../DesignInsightPage/DesignInsightPage';
import RadionicePage from '../RadionicePage/RadionicePage';
import VestiPage from '../VestiPage/VestiPage';
import PartneriPage from '../PartneriPage/PartneriPage';
import OrgPage from '../OrgPage/OrgPage';
import KontaktPage from '../KontaktPage/KontaktPage';
import Footer from '../Footer/Footer';

const HomePage = () => {
    

    return (
        <>
        <Background></Background>
        <Navbar></Navbar>
        <TimerPage></TimerPage>
        <DesignInsightPage></DesignInsightPage>
        <RadionicePage></RadionicePage>
        <VestiPage></VestiPage>
        <PartneriPage></PartneriPage>
        <OrgPage></OrgPage>
        <KontaktPage></KontaktPage>
        <Footer></Footer>
        </>
    );
    
}

export default HomePage;